<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader title="Team Content View">
        <el-select
          v-model="teamId"
          placeholder="Please select TeamName"
          filterable
          v-if="isShowFilter"
          class="select"
          @change="getTableDataInit"
        >
          <el-option
            v-for="(item, idx) in options"
            :key="idx"
            :label="item.teamName"
            :value="item.teamId"
          >
          </el-option>
        </el-select>
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Search"
          v-model="searchVal"
          class="select"
          v-debounce="onSearch"
          clearable
          @clear="onSearch"
        />
        <el-button
          type="primary"
          icon="el-icon-document-copy"
          @click="copyHandler()"
        >
          Copy Content
        </el-button>
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        @sort-change="onSortChange"
        ref="table"
        @selection-change="handleSelectionChange"
        v-loading="tableLoading"
        element-loading-text="Loading..."
      >
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column
          prop="MslName"
          :label="nameLabel"
          sortable="custom"
          width="130"
        />
        <el-table-column
          prop="TeamName"
          label="TeamName"
          sortable="custom"
          width="130"
        />
         <el-table-column
          prop="FileName"
          label="Content Name"
          sortable="custom"
          min-width="180"
        >
          <template #default="{ row }">
            <a :href="row.AttachmentPath" target="_blank">{{ row.FileName }}</a>
          </template>
        </el-table-column>
        
        <el-table-column
          prop="CategoryName"
          label="Category"
          sortable="custom"
          min-width="130"
        />
        <el-table-column
          prop="LevelName"
          label="Security Level"
          sortable="custom"
          min-width="140"
        />
        <el-table-column
          prop="CreatedOn"
          label="Create Date"
          sortable="custom"
          filter-multiple
          :formatter="rowDateFormatter"
          min-width="135"
        />
        <el-table-column
          prop="NoPush"
          label="No.Push"
          sortable="custom"
          min-width="110"
        />
        <el-table-column
          prop="UvIsRead"
          label="UV.Is Read"
          sortable="custom"
          min-width="120"
        />
        <el-table-column
          prop="RateOfHits"
          label="Rate of hits"
          sortable="custom"
          min-width="130"
        />
        <el-table-column
          prop="NoDownloads"
          label="No.Downloads"
          sortable="custom"
          min-width="150"
        />
         <el-table-column
          prop="UvDuration"
          label="UV.Duration(s)"
          sortable="custom"
          min-width="160"
        />
        <!-- <el-table-column prop="Operation" label="Operation" width="100">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="handleView(row)"
              icon="iconfont icon-view"
            >
              View
            </el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
    <ViewTeamPaperContentDialog
      :visible.sync="dialogPaperVisible"
      :data.sync="rowData"
    />
    <ViewTeamMeetingContentDialog
      :visible.sync="dialogMeetingVisible"
      :data.sync="rowData"
    />
    <ViewTeamUploadContentDialog
      :visible.sync="dialogUploadVisible"
      :data.sync="rowData"
    />
  </div>
</template>
<script>
import moment from "moment";
import ViewTeamPaperContentDialog from "../team_content/view-paper-team-content";
import ViewTeamMeetingContentDialog from "../team_content/view-meeting-team-content-dialog";
import ViewTeamUploadContentDialog from "../team_content/view-upload-team-content-dialog";
import { RoleCode } from "../../utils/role-constant";
export default {
  name: "Team-Content-View",
  components: {
    ViewTeamPaperContentDialog,
    ViewTeamMeetingContentDialog,
    ViewTeamUploadContentDialog,
  },
  data() {
    return {
      searchVal: "",
      teamId: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "CreatedOn",
      orderType: "descending",
      rowData: null,
      dialogPaperVisible: false,
      dialogMeetingVisible: false,
      dialogUploadVisible: false,
      tableData: [],
      multipleSelection: [],
      list: [],
      val: [],
      options: [],
      tableLoading: false,
      dateFormat: "YYYY-MM-DD",
    };
  },
  computed: {
    previewUrl() {
      return `${process.env.VUE_APP_SERVER}/upload/paper/`;
    },
    nameLabel() {
      const role = this.$store.state.role;
      let roleName = this.$store.state.userInfo.roleName;
      roleName = roleName === "ClinTrans" ? "Clin-trans" : roleName;
      if(roleName=='vML'){
        return 'MSL'
      }else{
        return role === RoleCode.ML || role === RoleCode.Supervisor
        ? "MSL"
        : roleName;
      }
    },
    role() {
      return this.$store.state.role;
    },

    isShowFilter() {
      return this.role === RoleCode.ML ||this.role === RoleCode.VMSL || this.role === RoleCode.Supervisor ;
    },
  },
  created() {
    this.getTableData();
    this.getOptions();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getTableData();
      }
    });
  },
  methods: {
    rowDateFormatter(row, column, cellValue) {
      return moment(new Date(cellValue)).format(this.dateFormat);
    },
    getOptions() {
      this.axios.get(`/content/teamList`).then(({ code, data, msg }) => {
        if (code == 200) {
          this.options = [
            {
              teamName: "All",
              teamId: "",
            },
            ...data,
          ];
        } else {
          this.$message({
            type: "error",
            message: msg,
          });
        }
      });
    },
    getTableDataInit() {
      this.currentPage = 1;
      this.getTableData();
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        teamId: this.teamId,
        key: this.searchVal,
      };
      this.axios
        .get(`/content/viewTeamContent`, { params: params })
        .then(({ code, data, msg }) => {
          if (code == 200) {
            this.tableData = data.data;
            this.total = data.total;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    copyHandler() {
      if (this.multipleSelection.length != 0) {
        this.axios
          .post(`/content/copyTeamContent`, {
            papers: this.multipleSelection,
          })
          .then(({ code, msg }) => {
            if (code == 200) {
              this.$emit("success");
              this.$message.success(`Copy content(s) successfully`);
              this.getTableData();
            } else {
              this.$message({
                type: "error",
                message: msg,
              });
            }
          });
      } else {
        this.$message.warning("Please select at least one");
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = Array.from(val, (i) => {
        return {
          paperId: i.PaperID,
          PaperCategoryID:i.categoryId,
        };
      });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },

    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    handleView(row) {
      this.rowData = row;
      if (row.FromAnzo) {
        this.dialogUploadVisible = true;
      } else {
        if (row.CategoryName === "") {
          this.dialogMeetingVisible = true;
        } else {
          this.dialogPaperVisible = true;
        }
      }
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.choose-title {
  width: 80px;
  font-size: 8px;
  margin-left: 20px;
  margin-right: 8px;
}
.icon-view-wrap {
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: #0078a3;
  align-items: center;
  border: 0px;
}
.pagination-wrap {
  margin-top: 10px;
}
.select {
  margin-right: 15px;
  width: 200px;
}
</style>
